<div
    *transloco="let t"
    [class]="'bazis-control ' + cssClassSizeControl"
>
    <bazis-label
        [isMajor]="hasTitleMajor"
        [isEmptyLabel]="isEmptyLabel"
        [title]="title || t(titleKey, titleParams)"
        [required]="required$ | async"
    >
        <bazis-interrogation
            *ngIf="tooltipKey"
            [slot]="tooltipSettings?.targetSide"
            iconSize="compact"
            [tooltipText]="t(tooltipKey, tooltipParams)"
            [tooltipOffset]="[-8, 4]"
            [tooltipEventType]="tooltipSettings?.eventType || 'hover'"
            [tooltipPlacement]="tooltipSettings?.placement || 'top-start'"
            [icon]="icons.interrogation"
            [type]="interrogationType"
        ></bazis-interrogation>
    </bazis-label>

    <div class="bazis-control__field-group bazis-control__field-group_estimated">
        <bazis-control-field-start
            [icon]="leftIcon"
            [tooltipText]="t(tooltipKey, tooltipParams)"
            [tooltipSettings]="tooltipSettings"
        >
        </bazis-control-field-start>
        <input
            *ngIf="!entityType; else tplEntityType"
            class="bazis-control__field"
            [formControl]="field"
            readonly
        />
        <ng-template #tplEntityType>
            <ng-container *ngIf="field.value | entity : entityType | async as entity">
                <div class="bazis-control__field">
                    <ng-container *ngIf="!displayTpl">{{
                        entity.$snapshot[nameField]
                    }}</ng-container>

                    <ng-container
                        *ngIf="displayTpl"
                        [ngTemplateOutlet]="displayTpl"
                        [ngTemplateOutletContext]="{ item: entity }"
                    >
                    </ng-container>
                </div>
            </ng-container>
        </ng-template>

        <bazis-control-field-end
            [isClickable]="isRightIconClickable"
            [icon]="rightIcon"
            [tooltipText]="t(tooltipKey, tooltipParams)"
            [tooltipSettings]="tooltipSettings"
            [unitText]="unit || t(unitKey)"
            (actionClick)="onRightIconClick($event)"
        >
        </bazis-control-field-end>
    </div>

    <div class="bazis-control__error">
        <bazis-form-error [formControl]="ngControl.control"></bazis-form-error>
    </div>

    <div
        *ngIf="noteKey"
        class="bazis-control__note"
    >
        {{ t(noteKey, noteParams) }}
    </div>
</div>
